import { QueryClient } from '@tanstack/react-query'
import LoadingSpinner from './components/ui/loading-spinner'
import { routeTree } from './routeTree.gen'
import { createRouter } from '@tanstack/react-router'
import NotFound from './pages/not-found'
import { ErrorFallback } from './pages/error-fallback'
import { clearEntityTags } from './lib/sentry/entity-tags'

export const router = createRouter({
  routeTree,
  context: { queryClient: undefined! },
  defaultPendingComponent: LoadingSpinner,
  defaultNotFoundComponent: NotFound,
  defaultErrorComponent: ErrorFallback,
  defaultPendingMs: 200,
})

// The browser Sentry scope is global + long-lived. Clear entity tags before
// every navigation so a stale intervention_id/invoice_id can't mis-tag errors
// on the next page; the destination route's loader re-stamps its own id.
router.subscribe('onBeforeNavigate', () => {
  clearEntityTags()
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
    context: {
      queryClient: QueryClient
    }
  }
}
